import { render } from "./Antifrode.vue?vue&type=template&id=73cdd709&scoped=true"
import script from "./Antifrode.vue?vue&type=script&lang=js"
export * from "./Antifrode.vue?vue&type=script&lang=js"

import "./Antifrode.vue?vue&type=style&index=0&id=73cdd709&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_assitech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cdd709"]])

export default __exports__